const { getYear } = require('./getYear')

module.exports.getCurrentYear = function getCurrentYear () {
  const date = new Date()

  return getYear(date)
}
